import { Dispatch } from 'redux';
import { isEmpty } from 'lodash';
import { directionActions } from '../slices/direction-slice';
import { ApiDirection } from '../http';

const {
  setDirectionRequestStart,
  setDirectionRequestSuccess,
  setDirectionRequestFailure,
  setDirectionRequestDefault,

  setDirectionListRequest,
  setDirectionListSuccess,
  setDirectionListFailure,
  setDirectionListDefault,

  setDirectionOneRequest,
  setDirectionOneSuccess,
  setDirectionOneFailure,
  setDirectionOneDefault,

  setDirectionWarehouseRequest,
  setDirectionWarehouseSuccess,
  setDirectionWarehouseFailure,
  setDirectionWarehouseDefault,
} = directionActions;

//List
export const getDirections = (params: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setDirectionListRequest());
  try {
    const data = await ApiDirection.fetchAll(params);
    dispatch(setDirectionListSuccess(data));
  } catch ({ message }) {
    dispatch(setDirectionListFailure({ message }));
  }
};
export const clearDirections = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDirectionListDefault());
};

//One
export const getDirection = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setDirectionOneRequest());
  try {
    const data = await ApiDirection.fetchOne(id);
    dispatch(setDirectionOneSuccess(data));
  } catch ({ message }) {
    dispatch(setDirectionOneFailure({ message }));
  }
};
export const clearDirection = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDirectionOneDefault());
};

//Warehouse
export const forceGetDirectionWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDirectionWarehouseRequest());
  try {
    const data = await ApiDirection.fetchAll({ take: 9999 });
    dispatch(setDirectionWarehouseSuccess(data));
  } catch ({ message }) {
    dispatch(setDirectionWarehouseFailure({ message }));
  }
};
export const getDirectionWarehouse = () => async (dispatch: Dispatch<any>, getState: any) => {
  const storeStates = getState();
  const { warehouse } = storeStates.direction;
  if (isEmpty(warehouse.hits) && !warehouse.isLoading) {
    dispatch(forceGetDirectionWarehouse());
  }
};
export const clearDirectionWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDirectionWarehouseDefault());
};

//Create
export const createDirection = (data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setDirectionRequestStart());
  return new Promise((resolve, reject) => {
    ApiDirection.createOne(data)
      .then((res) => {
        dispatch(setDirectionRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setDirectionRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Edit
export const editDirection =
  (id: string | number, data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setDirectionRequestStart());
    return new Promise((resolve, reject) => {
      ApiDirection.updateOne(id, data)
        .then((res) => {
          dispatch(setDirectionRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setDirectionRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Delete
export const deleteDirection = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setDirectionRequestStart());
  return new Promise((resolve, reject) => {
    ApiDirection.deleteOne(id)
      .then((res) => {
        dispatch(setDirectionRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setDirectionRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Clear request
export const clearDirectionRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDirectionRequestDefault());
};
